<template>
  <div>
    <b-container v-for="(f, index) in factors" :key="f.value">
      <b-row>
        <h4>{{ f.text }}</h4>
      </b-row>
      <b-row>
        <b-button variant="info" @click="editParamFactorBandValue(f)">
          <b-icon icon="plus" aria-hidden="true"></b-icon>
          Добавить
        </b-button>
      </b-row>
      <b-row>
        <b-table striped hover :items="f.factorBands" :fields="fields">
          <template v-slot:head(zoneOrProperty)="data">
            {{ (paramType === 2 || paramType === 7) ? 'Вариант': 'Интервал'}}
          </template>
          <template v-slot:cell(destination)="data">
            {{ (data.item.destination == 1 ? 'Повышение' :'Понижение')}}
          </template>
          <template v-slot:cell(buttons)="data">
            <h5 class="buttons">
              <nobr>
                <b-link @click="editParamFactorBandValue(f, data.item)">
                  <b-icon variant="info" icon="pencil" size="lg"></b-icon>
                </b-link>
                &nbsp;
                <b-link @click="deleteRubricatorValue(f, data.item.paramFactorBandId)">
                  <b-icon variant="info" icon="x-circle" size="lg"></b-icon>
                </b-link>
              </nobr>
            </h5>
          </template>
        </b-table>


      </b-row>
      <b-row>&nbsp;</b-row>

    </b-container>
    <b-modal :id="'paramVitaminFactorBandModal' + factors[0].value" hide-footer size="lg" :title="currentFactorText">
      <VitaminFactorBandEdit @save-success="afterSave" v-bind:analit-id="this.analitId" v-bind:factor-band="currentFactorBand"
                      v-bind:factor-value="currentFactorValue" v-bind:factor-text="'Функциональный дефицит'" v-bind:param-type="this.paramType"></VitaminFactorBandEdit>
    </b-modal>


  </div>
</template>

<script>
import {host} from "@/constants";
import VitaminFactorBandEdit from "@/components/admin/analits/VitaminFactorBandEdit";

export default {
  components: {VitaminFactorBandEdit},
  props: ["analitId", "paramType"],
  name: "VitaminFactorBandList",
  data() {
    return {
      fields: [
        {
          key: 'factorName',
          label: 'Функциональный дефицит'
        },
        {
          key: 'priorityReport',
          label: 'Уровень связи аналита и дефицита',
          sortable: true
        },
        {
          key: 'destination',
          label: 'Направление изменения аналита',
          sortable: true
        },
        {
          key: 'buttons',
          label: ' ',
          sortable: false
        }
      ],
      error: "",
      loading: true,
      factors: [ {value: "Vitamin", text: "Интерпретация метаболомика", factorBands: []}
      ],
      currentFactorBand: null,
      currentFactorValue: null,
      currentFactorText: ''
    }
  },
  methods: {
    afterSave() {
      this.$bvModal.hide('paramVitaminFactorBandModal' + this.factors[0].value)
      this.loading = true
      this.fetchFactorsList()
    },
    editParamFactorBandValue(factor, item = null) {
      this.currentFactorBand = item
      this.currentFactorValue = factor.value
      this.currentFactorText = factor.text
      this.$bvModal.show('paramVitaminFactorBandModal' + this.factors[0].value)
    },
    deleteRubricatorValue(factor, paramId) {
      this.error = null;
      if (confirm('Вы уверены, что хотите удалить параметр?')) {
        this.loading = true;
        fetch(host + '/rest/params/' + this.analitId + '/factors/Vitamin/' + paramId, {
          method: 'DELETE',
          credentials: 'include',
          headers: {'Content-Type': 'application/json; charset=utf-8'}
        }).then(response => response.json())
            .then(json => {
              if (json.resultCode == 0) {


                console.log('Delete Success ' + json)

              } else {

                console.log('Delete Failed ' + json)
                this.error = json.message;
              }
              this.loading = false
              this.fetchFactorList(factor)
            }).catch(error => {
          this.error = error
          console.log(JSON.stringify(error))
          this.loading = false
        })
      }
    },
    fetchFactorsList() {
      for (let f of this.factors) {
        this.fetchFactorList(f)
      }
    },
    fetchFactorList(factor) {
      fetch(host + '/rest/params/' + this.analitId + '/factors/Vitamin', {
        credentials: "include"
      })
          .then(response => response.json())
          .then(json => {
            factor.factorBands = json.factorBands
            console.log(JSON.stringify(json))
          })
    }
  },
  mounted() {
    this.fetchFactorsList()

    //console.log('factorName = ' + this.factorName)
  }
}
</script>

<style scoped>
.buttons {
  text-align: -webkit-right!important;
  text-align: -moz-right!important;
  text-align: right!important;
}
</style>